document.documentElement.classList.remove('no-js');

function updateProductImage(gallery, imageUrl, altText, mediaId) {
  if (!gallery || !imageUrl) return;

  const main = gallery.querySelector('[data-main-product-image]');
  if (!main) return;

  // Shopify's image_tag can add responsive attributes. Removing them ensures
  // the selected thumbnail always becomes the visible image immediately.
  main.removeAttribute('srcset');
  main.removeAttribute('sizes');
  main.src = imageUrl;
  main.alt = altText || '';
  if (mediaId) main.dataset.mediaId = String(mediaId);

  gallery.querySelectorAll('[data-product-thumb]').forEach((thumb) => {
    const active = mediaId
      ? String(thumb.dataset.mediaId) === String(mediaId)
      : thumb.dataset.image === imageUrl;
    thumb.classList.toggle('is-active', active);
    thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
}

function getVariants(section) {
  const json = section && section.querySelector('[data-product-variants]');
  if (!json) return [];
  try {
    return JSON.parse(json.textContent);
  } catch (error) {
    console.warn('Def Creations: unable to read product variants.', error);
    return [];
  }
}

function updateSelectedVariant(section) {
  if (!section) return;

  const selects = Array.from(section.querySelectorAll('.variant-select'));
  if (!selects.length) return;

  const selectedOptions = selects.map((select) => select.value);
  const variants = getVariants(section);
  const variant = variants.find((item) =>
    item.options && item.options.every((value, index) => value === selectedOptions[index])
  );

  if (!variant) return;

  const idInput = section.querySelector('[data-variant-id]');
  const price = section.querySelector('[data-product-price]');
  const addButton = section.querySelector('[data-add-to-cart]');

  if (idInput) idInput.value = variant.id;
  if (price) price.textContent = variant.price;

  if (addButton) {
    addButton.disabled = !variant.available;
    addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
  }

  if (variant.featured_image) {
    const gallery = section.querySelector('[data-product-gallery]');
    updateProductImage(
      gallery,
      variant.featured_image,
      variant.featured_alt || '',
      variant.featured_media_id
    );
  }

  // Keep the selected variant reflected in the URL without reloading the page.
  if (window.history && window.history.replaceState) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
});

// Event delegation keeps the gallery working after Shopify Theme Editor
// dynamically reloads a section.
document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-product-thumb]');
  if (!thumb) return;

  event.preventDefault();
  const gallery = thumb.closest('[data-product-gallery]');
  updateProductImage(
    gallery,
    thumb.dataset.image,
    thumb.dataset.alt || '',
    thumb.dataset.mediaId
  );
});

document.addEventListener('change', (event) => {
  if (!event.target.matches('.variant-select')) return;
  const section = event.target.closest('[data-product-section]');
  updateSelectedVariant(section);
});
